import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { StringRequiredSchema } from '@/utils';

const SendEmailSchema = z.object({
  email: StringRequiredSchema('Please enter an email.').email(
    'Invalid email format.',
  ),
});

export type SendEmailForm = z.infer<typeof SendEmailSchema>;

export const SendEmailDefaultValues: SendEmailForm = {
  email: '',
};

export const useSendEmailForm = () => {
  const form = useForm({
    defaultValues: SendEmailDefaultValues,
    resolver: zodResolver(SendEmailSchema),
    reValidateMode: 'onBlur',
    disabled: false,
  });

  return form;
};
